import clsx from 'clsx';
import { Answer } from '../../types';
import { intlFormatMessageOutsideFC } from 'lib/utils/intlFormatMessageOutsideFC';
import styles from './question.module.css';

type props = {
  data?: Answer;
  index: number;
  onPress: (indexAnswerValue: number) => void;
  selected: boolean;
  atLeastOneSelected: boolean;
  result: number | null;
  totalVotes: number | null;
};

const Answer = ({
  selected,
  atLeastOneSelected,
  data,
  index,
  onPress,
  result,
  totalVotes,
}: props) => {
  const intl = intlFormatMessageOutsideFC();
  const resultReady = !(result == null);
  const totalVotesReady = !(totalVotes == null);

  function formatNumber(num: number) {
    return ('' + num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function ($1) {
      return $1 + '.';
    });
  }

  return (
    <div className={clsx(styles.answerWrapper)}>
      <div
        style={{
          width:
            resultReady && totalVotesReady
              ? `${(result * 100) / totalVotes}%`
              : '0%',
        }}
        className={clsx(
          styles.answerVotesGraphcBar,
          !resultReady && styles.answerVotesGraphcBarNoAnimation,
        )}
      />
      <p
        className={clsx(
          styles.answer,
          selected && styles.answerSelected,
          !selected && atLeastOneSelected && styles.answerDimmed,
          resultReady && styles.answerResult,
        )}
        onClick={() => {
          !resultReady && onPress(index);
        }}
      >
        {`${data?.text}`}
        {resultReady ? ':' : ''}
        <b>{`${
          resultReady
            ? `${formatNumber(result)} ${intl.formatMessage({
                id: 'store/live.chat-votes',
              })}`
            : ''
        }`}</b>
      </p>
    </div>
  );
};

export default Answer;
